import { render, staticRenderFns } from "./ExecucaoPendente.vue?vue&type=template&id=32ca216f&"
import script from "./ExecucaoPendente.vue?vue&type=script&lang=js&"
export * from "./ExecucaoPendente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports